import React, { Component } from "react";

import { updateProductSlipStatusByProductSlipIdRequest } from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { productSlipStatusList } from "store/ProductSlip/selector";
import { createStructuredSelector } from "reselect";

class ProductSlipStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      color: "",
    };
  }

  componentDidMount() {
    this.setStatusColor(this.props.status);
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    this.setStatusColor(nextprops.status);
  }

  productSlipStatusChange = (select) => {
    this.props.updateProductSlipStatusByProductSlipIdRequest(
      this.props.productSlipId,
      select.target.value
    );
  };

  setStatusColor = (status = this.props.status) => {
    const { color } = this.props.productSlipStatusList.find(
      (s) => s.value === String(status)
    );
    this.setState({
      color,
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="order-status">
          <select
            value={this.props.status}
            onChange={(e) => this.productSlipStatusChange(e)}
            className={"form-control " + this.state.color}
            disabled={this.props.disabled}
          >
            {this.props.productSlipStatusList.map((productSlipStatus) => (
              <option
                key={productSlipStatus.value}
                value={productSlipStatus.value}
              >
                {productSlipStatus.label}
              </option>
            ))}
          </select>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productSlipStatusList: productSlipStatusList(),
});

const withConnect = connect(mapStatetoProps, {
  updateProductSlipStatusByProductSlipIdRequest,
});

export default compose(withConnect, withRouter)(ProductSlipStatus);
